import { formatCpf } from './commissionPaymentValidation';
import { genderOptions } from './salesPartyFormOptions';
import {
  displayReferenceDate,
  maskReferenceDate,
} from '../components/postSaleDate';

const dateFields = ['birth_date', 'rg_issued_on'];
const lookupLockedFields = [
  'cpf',
  'birth_date',
  'gender',
  'name',
  'mother_name',
];
const lookupIndicatorFields = ['cpf', 'birth_date', 'name', 'mother_name'];
const internalProfileLockedFields = ['name', 'mother_name', 'email'];

export const salesPartyIdentityRows = ({ hasFormContext, roleLabel, t }) => [
  [
    [
      'cpf',
      t('SALES_PARTIES.FORM.CPF'),
      t('SALES_PARTIES.FORM.CPF_PLACEHOLDER'),
    ],
    [
      'birth_date',
      t('SALES_PARTIES.FORM.BIRTH_DATE'),
      t('SALES_PARTIES.ORIGIN.CONTACTED_ON_PLACEHOLDER'),
    ],
    ['gender'],
  ],
  [
    [
      'name',
      hasFormContext
        ? t('SALES_PARTIES.PERSONAL.FORM_NAME', { role: roleLabel })
        : t('SALES_PARTIES.FORM.NAME'),
      t('SALES_PARTIES.FORM.NAME_PLACEHOLDER'),
      'text',
    ],
    [
      'mother_name',
      t('SALES_PARTIES.FORM.MOTHER_NAME'),
      t('SALES_PARTIES.FORM.MOTHER_NAME_PLACEHOLDER'),
      'text',
    ],
    [
      'father_name',
      t('SALES_PARTIES.FORM.FATHER_NAME'),
      t('SALES_PARTIES.FORM.FATHER_NAME_PLACEHOLDER'),
      'text',
    ],
  ],
  [
    [
      'nationality',
      t('SALES_PARTIES.FORM.NATIONALITY'),
      t('SALES_PARTIES.FORM.NATIONALITY_PLACEHOLDER'),
      'text',
    ],
    ['phone'],
  ],
  [
    [
      'profession',
      t('SALES_PARTIES.FORM.PROFESSION'),
      t('SALES_PARTIES.FORM.PROFESSION_PLACEHOLDER'),
      'text',
    ],
    [
      'email',
      t('SALES_PARTIES.FORM.EMAIL'),
      t('SALES_PARTIES.FORM.EMAIL_PLACEHOLDER'),
      'email',
    ],
  ],
  [
    [
      'rg',
      t('SALES_PARTIES.FORM.RG'),
      t('SALES_PARTIES.FORM.RG_PLACEHOLDER'),
      'text',
    ],
    [
      'rg_issuer',
      hasFormContext
        ? t('SALES_PARTIES.PERSONAL.FORM_RG_ISSUER')
        : t('SALES_PARTIES.FORM.RG_ISSUER'),
      t('SALES_PARTIES.FORM.RG_ISSUER_PLACEHOLDER'),
      'text',
    ],
    [
      'rg_issued_on',
      hasFormContext
        ? t('SALES_PARTIES.PERSONAL.FORM_RG_ISSUED_ON')
        : t('SALES_PARTIES.FORM.RG_ISSUED_ON'),
      t('SALES_PARTIES.ORIGIN.CONTACTED_ON_PLACEHOLDER'),
    ],
  ],
];

export const salesPartyIdentityGenders = t => genderOptions(t);

export const salesPartyIdentityInputValue = (identity, field) => {
  if (field === 'cpf') return formatCpf(identity[field]);
  if (dateFields.includes(field)) return displayReferenceDate(identity[field]);
  return identity[field];
};

export const salesPartyIdentityInputMode = field =>
  ['cpf', ...dateFields].includes(field) ? 'numeric' : undefined;

export const salesPartyIdentityMaxLength = field => {
  if (field === 'cpf') return 14;
  return dateFields.includes(field) ? 10 : undefined;
};

export const salesPartyIdentityFieldError = ({ errors, field, lookupError }) =>
  field === 'cpf' ? lookupError || errors[field] : errors[field];

export const salesPartyIdentityLookupLocked = ({
  field,
  lookupLoading,
  internalProfile,
}) =>
  (lookupLoading && lookupLockedFields.includes(field)) ||
  (internalProfile && internalProfileLockedFields.includes(field));

export const salesPartyIdentityShowsLookupIndicator = ({
  field,
  lookupLoading,
}) => lookupLoading && lookupIndicatorFields.includes(field);

export const normalizeSalesPartyIdentityInput = (field, value) => {
  if (dateFields.includes(field)) return maskReferenceDate(value);
  if (field === 'cpf') return formatCpf(value);
  return value;
};

export const salesPartyIdentityRequired = ({ field, hasRg }) =>
  !['father_name', 'email', 'rg'].includes(field) &&
  (!['rg_issuer', 'rg_issued_on'].includes(field) || hasRg);
